export default "__VITE_ASSET__DV5RAImn__"